import { useCallback } from 'react';
import { localePath } from '@/i18n/paths';
import { useTranslation } from '@/i18n/i18n';

export function useLocalizedPath() {
  const { locale } = useTranslation();
  return useCallback((path: string) => localePath(path, locale), [locale]);
}
